import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import ChannelOptionButton from './elements/channel-option-button';
import { colors, DisableNotificationIcon } from '@aftersale-next/ui';
export default function DisableNotificationOption(props) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(ChannelOptionButton, {
    label: t('NOT_NOTIFY'),
    Icon: /*#__PURE__*/_jsx(DisableNotificationIcon, {}),
    accent: colors.gray,
    onClick: props.onClick
  });
}